export const getTicketQuantity = (flightProduct) => {
    var _a;
    const ticket = {};
    (_a = flightProduct.lineItems) === null || _a === void 0 ? void 0 : _a.filter(({ description }) => description.indexOf('Ticket') !== -1).forEach((item) => {
        if (!ticket[item.description])
            ticket[item.description] = item.quantity;
    });
    return Object.values(ticket).reduce((acc, qty) => acc + qty, 0);
};
export const validateFlightDetails = (flight) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return Boolean(flight &&
        ((_a = flight.inboundLeg) === null || _a === void 0 ? void 0 : _a.duration) &&
        ((_d = (_c = (_b = flight.inboundLeg.segments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.airline) === null || _d === void 0 ? void 0 : _d.name) &&
        ((_e = flight.outboundLeg) === null || _e === void 0 ? void 0 : _e.duration) &&
        ((_h = (_g = (_f = flight.outboundLeg.segments) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.airline) === null || _h === void 0 ? void 0 : _h.name));
};
export const getStops = (stops, resourceStrings) => {
    const { HC_STOP, HCSTOPS, HC_DIRECT } = resourceStrings;
    const stopText = stops === 1 ? HC_STOP : HCSTOPS;
    return stops > 0 ? `${stops} ${stopText}` : HC_DIRECT;
};
